import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    marker: null,
    topRated: []
  },
  mutations: {
    SET_NEW_CENTER (state, center) {
      state.center = center
    },
    CLEAR_MARKER_DATA (state) {
      state.marker = null
    },
    SET_MARKER_DATA (state, m) {
      state.marker = {
        osm_id: m.id,
        location: {
          lat: m.lat,
          lng: m.lon
        },
        rating: {},
        name: m.tags ? m.tags.name : 'Unnamed',
        opening_hours: m.tags && m.tags.opening_hours,
        tags: m.tags
      }
    },
    SET_TOP_RATED  (state, payload) {
      state.topRated = payload
    }
  },
  actions: {
  }
})
